import TextOption from '@components/Test/Option/OptionContent/TextOption';
import PicsOption from '@components/Test/Option/OptionContent/PicsOption';
import {PICS, SHORT, TEXT} from '@constants/test';
import type {ReactElement} from 'react';

interface Props {
    type: string;
    modifier: string;
    content: string;
}

export default function OptionContent(props: Props): ReactElement<Props> {
    return (
        <>
            {(props.type === TEXT || props.type === SHORT) && (
                <TextOption text={props.content} {...props} />
            )}
            {props.type === PICS && <PicsOption image={props.content} {...props} />}
        </>
    );
}
